import { render, staticRenderFns } from "./FulfillmentOptionDisclaimer.vue?vue&type=template&id=387089c2&scoped=true"
import script from "./FulfillmentOptionDisclaimer.vue?vue&type=script&lang=ts"
export * from "./FulfillmentOptionDisclaimer.vue?vue&type=script&lang=ts"
import style0 from "./FulfillmentOptionDisclaimer.vue?vue&type=style&index=0&id=387089c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387089c2",
  null
  
)

export default component.exports